import { DropdownButton, Dropdown } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"



const Form_telefonino = (props) => {
  
    const [input_locale, SET_input_locale] = useState('');

    useEffect(() => {
//        console.log('XXXXXXXXXXXXXXXXXX dentro Useeffect')
//        console.log(props.input_ridotto)

        if (props.input_ridotto >-1) {
            let result = props.orario.map(a => a.indice_orario);     
            let index = result.indexOf(props.input_ridotto)

        //        Carica_progetti_esistenti_per_classe()
        //        Carica_progetti_esistenti()
            SET_input_locale(prevInput => {
            return {
                ...prevInput,
                ['indice_orario']: props.input_ridotto,
                ['orario']: props.orario[index].orario
            }
        })
    }
//    console.log('parametro_passato' + props.parametro_passato)
//    console.log('input_ridotto' + props.input_ridotto)
    }, [props.input_ridotto]);


    const handleSelect = (item_id) => {
        
        console.log('ciao ' + item_id + ' '  + input_locale)
      

        let obj = JSON.parse(item_id)

        props.SET_input(prevInput => {
            return {
                ...prevInput,
                [props.parametro_passato]: obj.indice_orario
            }
        })
        SET_input_locale(obj)

    }


    const metti_orario_corretto = (orario_passato) => {

//        let index = props.orario.indice_orario.indexOf(orario_passato)
        
        let result = props.orario.map(a => a.indice_orario);     
        let index = result.indexOf(orario_passato)
        
        if (index>-1) {
            return <>
            {props.orario[index].orario}
            </>
        }
    }  

    const metti_orario_corretto1 = (orario_passato) => {

        //        let index = props.orario.indice_orario.indexOf(orario_passato)
        console.log('orario_passato' + orario_passato)   
                
                let result = props.orario.map(a => a.indice_orario);     
                console.log(result)   
               let index = result.indexOf(orario_passato)
                console.log(index)   
                console.log(props.orario[index].orario)   
                
                if (index>-1) {
                    return <>
                    {props.orario[index].orario}
                    </>
                }
            }  
        

    return (
    <> 

        {!props.giornata_da_modificare && <> 
            {props.input_ridotto == -1 ? '-' : <> {props.evento} {input_locale.orario} </>}
            
        </> 
        }
        {props.giornata_da_modificare &&  props.presenza_alunno == 1 && <> 

            
           {props.parametro_passato.includes("_in") && <small>ora di arrivo</small>}
           {props.parametro_passato.includes("_out") && <small>ora di uscita</small>}

           {props.evento}
           <DropdownButton
            variant="primary"
            title={props.input_ridotto == undefined ? props.evento : <> {input_locale.orario} </>}
            onSelect={handleSelect} >
                {props.orario.map(function (item1, index2) {
                    {
                        return <div>
                             <Dropdown.Item eventKey={JSON.stringify(item1)}> {item1.orario}  </Dropdown.Item>
                        </div>
                    }
                })
                }
                <Dropdown.Divider />
            </DropdownButton>
            </>
        }
    </>
    )

}
export default Form_telefonino;